import { Grid } from '@tonic-one/react';

import ReportTemplate from './ReportTemplate';
import BlockTitle from '../../BlockTitle';
import { useTranslation } from 'react-i18next';
import ReportDataPeriod from './ReportDataPeriod';
import ReportSections from './ReportSections';

export const ReportContent = () => {
  const { t } = useTranslation();
  return (
    <>
      <BlockTitle
        content={t('reportCommon.titles.reportContent')}
        paddingTop="59px"
      />
      <Grid
        templateColumns="130px max-content"
        // columnGap="10x"
        rowGap="3x"
      >
        <ReportTemplate />
        <ReportDataPeriod />
        <ReportSections />
      </Grid>
    </>
  );
};
